<template>
    <section class="byline">
        <!-- left column -->
        <div>
            <!-- author row -->
            <div>
                <template v-if="portraitPossible">
                    <img v-if="portraitUrl" :src="portraitUrl" loading="lazy"/>
                    <i v-else class="fa-light fa-user" aria-hidden="true"></i>
                </template>

                <span v-if="authorName">
                    <template v-if="normalizedAuthorLink">
                        <a :href="normalizedAuthorLink">
                            {{ bbReplace(bundle.id_1513, authorName) }}
                        </a>
                    </template>
                    <template v-else>
                        <span>{{ bbReplace(bundle.id_1513, authorName) }}</span>
                    </template>
                </span>
            </div>
        </div>
        <div class="byline-timestamps">
            <time>
                <i class="fa-light fa-clock" aria-hidden="true"></i>
                <span>{{ bylineTimestamp }}</span>
            </time>
        </div>
    </section>
</template>

<script>
import Vue from "vue";

export default {
    name: "blog-byline",
    props: {
        authorName: {type: String, default: ""},
        columnistId: {type: [Number, String, Object], default: null},
        administratorId: {type: [Number, String, Object], default: null},
        bylineDate: {type: [String, Object], default: null},
        authorLink: {type: String, default: ""},
        portraitUrlProp: {type: String, default: ""},
        language: {type: String, default: ""},
    },
    data() {
        return {
            bundle: {
                id_1513: "By {0}",
            },
            lastUpdated: null,
        };
    },
    created() {
        Vue.$bundle("portal", this.bundle, (bundle) => {
            this.bundle = bundle;
        });
    },
    mounted() {
    },
    beforeDestroy() {
    },
    computed: {
        portraitPossible() {
            return Boolean(this.columnistId || this.administratorId || this.portraitUrlProp);
        },
        portraitUrl() {
            return this.portraitUrlProp || null;
        },
        normalizedAuthorLink() {
            const link = (this.authorLink || "").trim();
            if (!link) return "";

            // If it looks like an email, make it mailto:
            if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(link)) {
                return `mailto:${link}`;
            }

            // If it already has a scheme, keep it:
            if (/^https?:\/\//i.test(link)) return link;

            // Otherwise treat as plain URL host/path:
            return `https://${link}`;
        },
        bylineTimestamp() {
            return this.timestampFormatted(this.bylineDate);
        }
    },
    methods: {
        toDate(value) {
            if (!value) return null;
            if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
            const d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
        },
        bbReplace(str, replaceStr) {
            return Vue.$bbUtil.block(str).replace("{0}", replaceStr);
        },
        timestampFormatted(timestamp) {
            const d = this.toDate(timestamp);
            if (!d) return "";
            return new Intl.DateTimeFormat(this.language, {
                dateStyle: "long",
                timeStyle: "short",
            }).format(d);
        },
    },
};
</script>
<style scoped lang="less">
.byline {
    border: none;
    margin: 0.75rem 0 1rem 0;
    padding: 0.75rem 0;
}
</style>